<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d;font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
    <v-row  >
      <v-col md="12" lg="12" cols="12">
        <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Usuarios {{negocio.negocio}}</h1>
        <br/>
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Usuario se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Usuario se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Usuario se edito con éxito.
       </v-alert>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on"><span class="hidden-sm-only hidden-xs-only">Nuevo Usuario</span><v-icon class=" hidden-md-only hidden-lg-only hidden-xl-only">fas fa-plus</v-icon></v-btn>
          </template>
          <v-card color="#393E46">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field  v-model="nuevUsuario.email"  type="email" @change="verificaremail" label="Email"></v-text-field>

                  </v-col>
                  <v-col  cols="12" sm="12" md="12" lg="12">
                    <v-text-field   v-model="nuevUsuario.nombre" label="Nombre"></v-text-field>
                  </v-col>
                  <v-col  cols="12" sm="12" md="12" lg="12">
                    <v-text-field   v-model="nuevUsuario.apellido" label="Apellido Paterno"></v-text-field>
                  </v-col>
                  <v-col v-if="emailexist"  cols="12" sm="12" md="12" lg="12">
                    <v-text-field  type="password"  v-model="nuevUsuario.password" label="Apellido Paterno"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-data-table
      :headers="headers"
      :items="Usuarios"
      sort-by="email"
      sort-desc
      class="elevation-1"
      :search="search"
      :loading="progr"
      no-data-text="No hay datos disponibles para mostrar."
      no-results-text="No hay resultados para la búsqueda."
      loading-text="Cargando... Por favor espere."
      style="background-color: #393E46;"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title>Usuarios</v-toolbar-title>
          <v-btn @click="dameUsuarios"><v-icon>fas fa-sync-alt</v-icon></v-btn>

          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>

          <v-dialog v-model="dialogdelete" persistent max-width="350">
        <v-card color="#393E46">
          <v-card-title class="headline">Desea eliminar esta Usuario?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          small
          color="blue"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>
        <v-icon
          small
          color="error"
          @click="deleteItem(item)"
        >
          fas fa-minus-circle
        </v-icon>
      </template>
      <template v-slot:[`item.dactiva`]="{ item }">
        <v-switch v-model="item.activo" @click="activaItem(item)" ></v-switch>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="dameUsuarios">Cargar de Nuevo</v-btn>
      </template>
    </v-data-table>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import md5 from "js-md5";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Usuarios | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      negocio: {},
        pemail:'',
        emailexist:false,
        pnombres:'Sí',
        pappaterno:'',
      nuevUsuario:{
        email:'',
        nombre:'',
        apellido:'',
        negocioId:0,
        grupoUsuarioId:0,
        password:''
      },
      nuevoUsuario:{
        email:'',
        nombre:'',
        apellido:'',
        negocioId:0,
        grupoUsuarioId:0,
        password:''
      },
      token:'',
      abreviado:'NN',
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Usuarios',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      dialog: false,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      usuarios: [],
      search: '',
      editedIndex: -1,
      editedItem: {
        usuarioId: 0,
        email: '',
        grupoDTO: {
          grupoId:0,
          grupoNombre: ''},
        clienteDTO: {
          clienteId:0,
          clienteNombre: '',
          clienteTag: '',
          clienteLogo: '',
          clienteDeuda:false,
          clienteNegocios:false,
          clienteEventos:false},
        personaDTO: {
          personaId:0,
          personaNombre: '',
          personaDni: '',
          personaFoto: '',
          personaDniFoto:'',
          personaPaisNacId:0,
          personaPaisNac:''},
        isprofile:false,
        isfoto: false,
        isverified: false,
        uidFirebase:''
    },
    defaultItem: {
      id: null,
      grupoUsuario:{},
      negocio:{},

    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Usuario', align: 'left',  value: 'persona.nombre'},
        { text: 'Activa', value: 'dactiva' },
        { text: 'Tipo de Usuario', value: 'grupoUsuario.grupo' },
      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
              this.dameUsuarios();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      this.dameUsuarios();
    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });
      }else {
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
        this.dameUsuarios();
      }

    },
  },
  methods : {
    dameUsuarios(){
      this.progr = true;
            let urlUsuario = 'personas/negocio/' + this.idnegocio;
        axios
        .get(urlUsuario,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Usuarios = response.data.filter(item => item.persona.id != 1);
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
          this.progr = false;
        });
    },
    activaItem (item) {
      this.editedItem = Object.assign({}, item)
      var bodyFormData2 = new FormData();
      bodyFormData2.append("data",JSON.stringify(this.editedItem));

      axios
      .post('usuarios/editar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.editedIndex = this.Usuarios.indexOf(item);
               this.Usuarios = response.data;

      })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    editItem (item) {
      this.editedIndex = this.Usuarios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.Usuarios.indexOf(item);
      this.dialogdelete = true;
    },
    borralo (){
      let md555 = md5(this.Usuarios[this.editedIndex].usuarioId.toString());
      axios
      .delete('usuarios/'+md555,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.Usuarios = response.data;

      })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
      verificaremail(){
          this.overlay=true;
          var bodyFormData2 = new FormData();
          bodyFormData2.append("email",this.pemail);
          axios
              .post('personas/email',bodyFormData2,{
                  headers: {
                      'Authorization': `Bearer ${this.token}`,
                  }
              })
              .then(response => {
                  this.overlay=false
                  let persona = response.data
                  if (persona.uidFirebase == null){
                      this.emailexist = true
                  }

              })
              .catch((error)  => {
                  this.overlay = false
                  console.log(error);
              });
      },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.Usuarios[this.editedIndex], this.editedItem);
        var bodyFormData2 = new FormData();
        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
      .post('usuarios/editar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
          this.Usuarios = response.data;
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      } else {
        var bodyFormData = new FormData();
        this.editedItem.negocioDTO.negocioId = this.negocio.negocioId;
        this.editedItem.negocioDTO.negocioNombre = this.negocio.negocio;
        this.editedItem.negocioDTO.negocioLogo = this.negocio.Logo;
        this.editedItem.negocioDTO.negocioTag = this.negocio.tag;
        this.editedItem.clienteDTO.clienteId = this.cliente.clienteId;
        this.editedItem.clienteDTO.clienteNombre = this.cliente.clienteNombre;
        this.editedItem.clienteDTO.clienteTag = this.cliente.clienteTag;
        this.editedItem.clienteDTO.clienteLogo = this.cliente.clienteLogo;
        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('usuarios/editar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
          this.Usuarios = response.data;
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Usuario' : 'Editar Usuario'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
